import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get mail recognize spam
 * */
export function* getMailRecognizeSpamList() {
    const response = yield call(api.getMailRecognizeSpamList);

    if (response) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `Spam list updated`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        yield put({
            type: actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: 'Spam list didn`t update',
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 2,
        },
    });

    yield put({
        type: actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.FAILURE,
    });

    return response;
}

export function* watchGetMailRecognizeSpamList() {
    while (true) {
        yield take(actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.REQUEST);
        yield fork(getMailRecognizeSpamList);
    }
}

/**
 * Get mail recognize spam
 * */
export function* updateMailRecognizeSpamList(data) {
    const response = yield call(api.updateMailRecognizeSpamList, data);

    if (response) {
        yield put({
            type: actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.FAILURE,
    });

    return response;
}

export function* watchUpdateMailRecognizeSpamList() {
    while (true) {
        const { data } = yield take(actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.REQUEST);
        yield fork(updateMailRecognizeSpamList, data);
    }
}

export default [
    watchGetMailRecognizeSpamList,
    watchUpdateMailRecognizeSpamList,
];



// WEBPACK FOOTER //
// ./app/sagas/preferences/mailRecognizeSpamList.js